import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { globalStyles, skeletonStyles } from '../global-styles.js'

@customElement('pp-skeleton')
export class PpSkeleton extends LitElement {
  static styles = [
    globalStyles,
    skeletonStyles,
    css`
      :host {
        width: 100%;
        display: block;
        border-radius: 0.5rem;
      }
    `
  ];
  render() {
    return html`
      <div class="LOADING-container LOADING-double">
        <div class="LOADING-checkoutPayment">
          <div class="grid grid-2-1 gap-6">
            <div class="LOADING-payment-header LOADING-loads"></div>
            <div class="LOADING-payment-header LOADING-loads"></div>
          </div>
          <div class="LOADING-payment-center">
            <div class="LOADING-payment-row LOADING-loads"></div>
            <div class="LOADING-payment-row LOADING-loads"></div>
            <div class="grid grid-1-1 gap-3">
              <div class="LOADING-payment-row LOADING-loads"></div>
              <div class="LOADING-payment-row LOADING-loads"></div>
            </div>
            <div class="grid grid-1-1 gap-3">
              <div class="LOADING-payment-row LOADING-loads"></div>
              <div class="LOADING-payment-row LOADING-loads"></div>
            </div>
            <div class="grid grid-2-1 gap-6">
              <div class="LOADING-payment-text LOADING-loads"></div>
            </div>
            <div class="LOADING-button LOADING-loads"></div>
          </div>
        </div>
      </div>
    `;
  }
}
